import type { SlideTheme } from '@/types/slides'

export const theme: SlideTheme = {
  themeColor: '#5b9bd5',
  fontColor: '#333',
  fontName: 'Microsoft Yahei',
  backgroundColor: '#fff',
  shadow: {
    h: 3,
    v: 3,
    blur: 2,
    color: '#808080',
  },
  outline: {
    width: 2,
    color: '#525252',
    style: 'solid',
  },
}